module.exports = __webpack_public_path__ + "img/pieChart2.d323ff8e.png";